/**
 * Web-Mercator ground resolution (#44). Screen-anchored map markers do NOT scale with
 * zoom, so a to-scale overlay must recompute its pixel size whenever zoom changes.
 * This is our own math over our own dimensions — never derived from, and never
 * persisting, Google imagery. Generic: reused by both generator and solar placement.
 */

/** Meters of ground per screen pixel at a latitude/zoom (256px-tile basis). */
export function metersPerPixel(lat: number, zoom: number): number {
  return (156543.03392 * Math.cos((lat * Math.PI) / 180)) / 2 ** zoom;
}

/** Pixel length of a real-world span (meters) at the given lat/zoom. */
export function footprintPixels(realMeters: number, lat: number, zoom: number): number {
  return realMeters / metersPerPixel(lat, zoom);
}
